import { useState, useRef, useEffect, useCallback } from "react";
import { Layout, List } from "antd";
import { Document, Page, pdfjs } from "react-pdf";
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const { Sider, Content } = Layout;

const pdfFiles = [
  { name: "Tính Giá Cọc Tròn", url: "/pdfs/HDSD cọc ống.pdf" },
  { name: "Tính Giá Cừ Ván", url: "/pdfs/HDSD cừ ván.pdf" },
  { name: "Tính Giá Cọc Vuông", url: "/pdfs/HSSD CỌC VUÔNG.pdf" },
];

const ZOOM_STEP = 0.15;
const MIN_ZOOM = 0.5;
const MAX_ZOOM = 3.0;

const Usermanual = () => {
  const [selectedFile, setSelectedFile] = useState(pdfFiles[0].url);
  const [numPages, setNumPages] = useState(null);
  const [scale, setScale] = useState(1.0);
  const [containerWidth, setContainerWidth] = useState(0);
  const contentRef = useRef(null);

  // Đo chiều rộng phần tử cha để tính scale mặc định
  useEffect(() => {
    if (!contentRef.current) return;
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const w = entry.contentRect.width - 40; // trừ padding
        setContainerWidth(w > 0 ? w : 0);
      }
    });
    observer.observe(contentRef.current);
    return () => observer.disconnect();
  }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setScale(1.0); // reset zoom khi đổi file
  }

  const zoomIn = () => setScale((s) => Math.min(+(s + ZOOM_STEP).toFixed(2), MAX_ZOOM));
  const zoomOut = () => setScale((s) => Math.max(+(s - ZOOM_STEP).toFixed(2), MIN_ZOOM));
  const zoomFit = () => setScale(1.0);

  // Width thực sự truyền vào <Page>: containerWidth * scale
  // Khi scale=1, page vừa đúng container. Zoom thay đổi kích thước render.
  const pageWidth = containerWidth > 0 ? containerWidth * scale : undefined;

  return (
    <Layout style={{ height: "80vh", border: "1px solid #f0f0f0", borderRadius: 8, overflow: "scroll" }}>
      {/* LEFT - DANH SÁCH FILE */}
      <Sider
        width={200}
        style={{ background: "#fff", padding: "12px 8px", borderRight: "1px solid #f0f0f0" }}
      >
        <List
          dataSource={pdfFiles}
          renderItem={(item) => (
            <List.Item
              style={{
                cursor: "pointer",
                background: selectedFile === item.url ? "#e6f7ff" : "transparent",
                padding: "8px 12px",
                borderRadius: 6,
                marginBottom: 4,
                border: "none",
              }}
              onClick={() => { setSelectedFile(item.url); setNumPages(null); }}
            >
              {item.name}
            </List.Item>
          )}
        />
      </Sider>

      {/* RIGHT - VIEWER */}
      <Layout style={{ flexDirection: "column", overflow: "scroll" }}>
        {/* TOOLBAR zoom */}
        
        {/* PDF CONTENT */}
        <Content
          ref={contentRef}
          style={{ padding: 20, overflow: "auto", background: "#f5f5f5", flex: 1 }}
        >
          <Document
            file={selectedFile}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={(e) => console.error("Lỗi không thể tải PDF:", e)}
            loading={<div style={{ textAlign: "center", paddingTop: 40 }}>Đang tải tài liệu...</div>}
          >
            {numPages && Array.from({ length: numPages }, (_, i) => (
              <div
                key={`wrapper_${i}`}
                style={{ marginBottom: 20, display: "flex", justifyContent: "center" }}
              >
                <Page
                  key={`page_${i + 1}`}
                  pageNumber={i + 1}
                  width={pageWidth}
                  renderTextLayer={true}
                  renderAnnotationLayer={false}
                />
              </div>
            ))}
          </Document>
        </Content>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "6px 16px",
            borderBottom: "1px solid #f0f0f0",
            background: "#fafafa",
            flexShrink: 0,
          }}
        >
          <button
            onClick={zoomOut}
            disabled={scale <= MIN_ZOOM}
            style={{
              width: 30, height: 30, border: "1px solid #d9d9d9", borderRadius: 4,
              background: "#fff", cursor: scale <= MIN_ZOOM ? "not-allowed" : "pointer",
              fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center",
            }}
          >−</button>

          <span
            onClick={zoomFit}
            title="Nhấn để về 100%"
            style={{
              minWidth: 52, textAlign: "center", fontSize: 13,
              fontWeight: 500, cursor: "pointer", userSelect: "none",
              padding: "2px 6px", borderRadius: 4,
              border: "1px solid #d9d9d9", background: "#fff",
            }}
          >
            {Math.round(scale * 100)}%
          </span>

          <button
            onClick={zoomIn}
            disabled={scale >= MAX_ZOOM}
            style={{
              width: 30, height: 30, border: "1px solid #d9d9d9", borderRadius: 4,
              background: "#fff", cursor: scale >= MAX_ZOOM ? "not-allowed" : "pointer",
              fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center",
            }}
          >+</button>

          {numPages && (
            <span style={{ marginLeft: "auto", fontSize: 12, color: "#888" }}>
              {numPages} trang
            </span>
          )}
        </div>
      </Layout>
    </Layout>
  );
};

export default Usermanual;